import React, { useEffect, ComponentType, useState, useRef } from "react";
import { Form, Modal, notification, TableColumnsType, TableProps, Progress } from "antd";
import type { FormInstance } from "antd/es/form";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import useSWR from "swr";
function StartLicense(stimulsoftInstance: any) {
    const key = process.env.REACT_APP_STIMULSOFT_LICENSE_KEY;
    if (key && key.trim() !== "") {
        try {
            stimulsoftInstance.Base.StiLicense.key = key.trim();
        } catch (error: any) { }
    } else {
        const hardcodedKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmKmIYtQbGVffUafn4grxXukjNz+mLI/d2lO8A9DuHxAxu4MmrN4lqhtklB0Pcnfq+AIk+1s6kU0D6JIIxpfQs1FV6pzwrzAWDLexRPvVgpswR/C5n69gFjFmWmtV0bGCTAj6H/MHgwElWYT9nYccmuFH0sfAj7VELa2HehqREJ7di+05AWeWIScfcWsf0XZ3JK+2X3reYvhUEAxrCwX3FDw2p1hPQIfiUVkUd4NRvfwWBLOjP2ZTfp9dzNe1D6T7miK1VBd731o/ex6q1bkdNH+G1KV6OLxdQwb9zWr4AR0QtMKwrphskgAYb5PMCectoVCeRFKtWSm8qnMP+GN8v0GHbJGQ/ZYWMAsE94nCEhnJz9T/xfy1b6WEWqpUUjVsfPzm/naRz0bxVN+AtFW7thTBMwGXoKTJXnKhfrI5u/fRffUu78ejnazBjWCHANN/xF7XOLhnFWw5JZHPXkaoCbiG8kBL3bgL4DtSyZ7jecAPmJUtainwLNMdo75J6hvu/pS+jDUs2tqRjEv6PTehXg";
        try {
            stimulsoftInstance.Base.StiLicense.key = hardcodedKey;
        } catch (fallbackError: any) { }
    }
}
const stockFetcher = (url: string) => axios.get(url).then(res => res.data);


interface DataType {
    key: React.Key;
    itemNumber: string;
    itemName: string;
    uom: string;
    locationCode?: string;
    qtyAvailable: number;
    qtyRequest: number;
    qtyOut: number;
}


interface SelectedData {
    requestNo: string;
    requestDate: string;
    fromWhCode: string;
    fromWhName: string;
    toWhCode: string;
    toWhName: string;
    purpose: string;
    requestBy: string;
    requestByName: string;
    approval: string;
    approvalByName: string;
    approvalDate: string;
    approvalRemark: string;
}

interface LocationData {
    key: string;
    locationCode: string;
    locationName: string;
}

type AutosaveStatus = 'idle' | 'processing' | 'error' | 'stopped';

interface WithTransferOutLogicProps {
    form: FormInstance;
    columns: TableColumnsType<DataType>;
    rowSelection: TableProps<DataType>["rowSelection"];
    dataSource: DataType[];
    isModalOpen: boolean;
    showModal: () => void;
    handleCancel: () => void;
    handleRowDoubleClick: (record: SelectedData) => void;
    isDataSelected: boolean;
    isEditModalOpen: boolean;
    handleEditModalCancel: () => void;
    handleTableauRowDoubleClick: (record: DataType) => void;
    editingRecord: DataType | null;
    isLocationModalOpen: boolean;
    showLocationModal: () => void;
    handleLocationModalCancel: () => void;
    currentWarehouseCode: string | null;
    handleLocationSelect: (record: LocationData) => void;
    handleEditFormSubmit: (values: any) => void;
    userWarehouseCode: string | undefined;
    handleCopyFromReceipt: () => void;
    handleDelete: () => void;
    autosaveStatus: AutosaveStatus;
    handleNew: () => void;
    handleSubmit: () => void;
    handleVoid: () => void;
    invalidRowKeys: React.Key[];
    isSubmitDisabled: boolean;
    isProcessing: boolean;
    handlePrint: () => void;
    isPrinting: boolean;
    isPrintDisabled: boolean;
    isReportModalOpen: boolean;
    handleReportModalCancel: () => void;
}

const withTransferOutLogic = <P extends object>(
    WrappedComponent: ComponentType<P & WithTransferOutLogicProps>
) => {
    const ComponentWithLogic: React.FC<P> = (props) => {

        const [form] = Form.useForm();
        const { userData } = useAuth();
        const location = useLocation();
        const navigate = useNavigate()
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [isDataSelected, setIsDataSelected] = useState(false);
        const [dataSource, setDataSource] = useState<DataType[]>([]);
        const [isEditModalOpen, setIsEditModalOpen] = useState(false);
        const [editingRecord, setEditingRecord] = useState<DataType | null>(null);
        const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
        const [currentWarehouseCode, setCurrentWarehouseCode] = useState<string | null>(null);
        const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
        const [autosaveStatus, setAutosaveStatus] = useState<AutosaveStatus>('stopped');
        const [invalidRowKeys, setInvalidRowKeys] = useState<React.Key[]>([]);
        const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
        const [isProcessing, setIsProcessing] = useState(false);
        const [isPrinting, setIsPrinting] = useState(false);
        const [isReportModalOpen, setIsReportModalOpen] = useState(false);
        const warehouseCodeReq = Form.useWatch('warehouse_code_req', form);
        const debounceTimer = useRef<NodeJS.Timeout | null>(null);
    const isSubmittingRef = useRef(false);
        const formValues = Form.useWatch([], form);
        const transOutStatus = Form.useWatch('trans_out_status', form);
        const isPrintDisabled = transOutStatus === 'Draft';

        useEffect(() => {
            const { incomingRequest } = location.state || {};
            if (incomingRequest) {
                handleRowDoubleClick(incomingRequest);
                navigate('.', { replace: true, state: null });
            }
        }, [location.state]);

        const { data: latestStock } = useSWR(
            warehouseCodeReq ? `${process.env.REACT_APP_BACKEND_URL}/api/current-stocks/${warehouseCodeReq}` : null,
            stockFetcher,
            { refreshInterval: 5000 }
        );

        const formatDateToDDMMYYYY = (dateVal: any) => {
            if (!dateVal) return '';
            const str = String(dateVal).trim();
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) return str;
            if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
                const [year, month, day] = str.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            }
            const d = new Date(str);
            if (!isNaN(d.getTime())) {
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            }
            return str;
        };

        useEffect(() => {
            if (latestStock && dataSource.length > 0) {
                const updatedSource = dataSource.map(item => {
                    const matchingStock = latestStock.find((s: any) => s.item_code === item.itemNumber && s.location_code_rack === item.locationCode);
                    return matchingStock ? { ...item, qtyAvailable: parseInt(matchingStock.qty) } : item;
                });
                setDataSource(updatedSource);
            }
        }, [latestStock]);

        const getFormattedDate = () => {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const year = today.getFullYear();
            return `${day}/${month}/${year}`;
        };

        useEffect(() => {
            if (transOutStatus === 'Draft') {
                setIsSubmitDisabled(false);
            } else {
                setIsSubmitDisabled(true);
            }
        }, [transOutStatus]);

        useEffect(() => {
            const { selectedRecord } = location.state || {};

            if (selectedRecord) {
                const loadSelectedData = async () => {

                    form.resetFields();
                    setDataSource([]);
                    setIsDataSelected(false);
                    setSelectedRowKeys([]);
                    setInvalidRowKeys([]);

                    let statusText: string;
                    switch (selectedRecord.status) {
                        case '1':
                            statusText = 'Draft';
                            break;
                        case '2':
                            statusText = 'Accept';
                            break;
                        case '3':
                            statusText = 'Ready';
                            break;
                        case '4':
                            statusText = 'Reject';
                            break;
                        case '5':
                            statusText = 'Closed';
                            break;
                        case '6':
                            statusText = 'intransit';
                            break;
                        default:
                            statusText = 'Unknown';
                    }
                    const formattedTransDate = formatDateToDDMMYYYY(selectedRecord.transferDate);
                    const formattedReqDate = selectedRecord.trans_request_date ? new Date(selectedRecord.trans_request_date).toLocaleDateString('en-GB') : '';
                    const formattedApprovDate = selectedRecord.approval_date ? new Date(selectedRecord.approval_date).toLocaleDateString('en-GB') : '';

                    form.setFieldsValue({
                        created: selectedRecord.created,
                        trans_out_status: statusText,
                        trans_out_no: selectedRecord.transferOutNo,
                        trans_out_date: formattedTransDate,
                        trans_request_no: selectedRecord.transferRequestNo,
                        trans_request_date: formattedReqDate,
                        warehouse_name_req: selectedRecord.warehouseName,
                        warehouse_code_req: selectedRecord.warehouseCode,
                        warehouse_name_to: selectedRecord.warehouse_name_to,
                        warehouse_code_to: selectedRecord.warehouse_code_to,
                        purpose: selectedRecord.purpose,
                        approval_by: selectedRecord.approval_by,
                        approval_date: formattedApprovDate,
                        approval_remark: selectedRecord.approval_remark,
                    });


                    try {
                        const encodedTransOutNo = encodeURIComponent(selectedRecord.transferOutNo);
                        const detailsResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/transfer-out-details/${encodedTransOutNo}`);
                        const detailsData = detailsResponse.data.map((item: any, index: number) => ({
                            ...item,
                            key: `${item.itemNumber}-${Date.now()}-${index}`
                        }));
                        setDataSource(detailsData);
                    } catch (error) {
                        console.error("Failed to fetch transfer out details:", error);
                        notification.error({
                            message: "Error",
                            description: "Failed to load item details for the selected transfer.",
                            placement: "topRight",
                        });
                    }


                    setIsDataSelected(true);


                    if (selectedRecord.status !== '1') {
                        setAutosaveStatus('stopped');
                        setIsSubmitDisabled(true);
                    } else {
                        setAutosaveStatus('idle');
                        setIsSubmitDisabled(false);
                    }

                    navigate('.', { replace: true, state: null });
                };

                loadSelectedData();
            } else {
                if (!form.getFieldValue('trans_out_no')) {
                    form.setFieldsValue({
                        trans_out_status: "Draft",
                        trans_out_date: getFormattedDate(),
                        created: userData?.nama,
                    });
                }
            }
        }, [location.state, form, navigate, userData]);

        useEffect(() => {
            const transRequestNo = form.getFieldValue('trans_request_no');
            const status = form.getFieldValue('trans_out_status');

            if (!transRequestNo || status !== 'Draft') {
                if (autosaveStatus !== 'stopped') {
                    setAutosaveStatus('stopped');
                }
                return;
            }

            if (!transRequestNo) {
                setAutosaveStatus('stopped');
                return;
            }

            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            setAutosaveStatus('processing');

            debounceTimer.current = setTimeout(async () => {
                try {
                    const headerData = form.getFieldsValue(true);

                    if (!headerData.trans_out_no) {
                        console.warn("Autosave dilewati: trans_out_no tidak ditemukan.");
                        setAutosaveStatus('error');
                        return;
                    }

                    const payload = {
                        header: headerData,
                        details: dataSource,
                    };

                    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/save-transfer-out`, payload);

                    setAutosaveStatus('idle');
                } catch (error) {
                    console.error("Autosave gagal:", error);
                    notification.error({
                        message: "Autosave Gagal",
                        description: "Terjadi kesalahan saat menyimpan data Anda secara otomatis.",
                        placement: "topRight",
                    });
                    setAutosaveStatus('error');
                }
            }, 2000);

            return () => {
                if (debounceTimer.current) {
                    clearTimeout(debounceTimer.current);
                }
            };
        }, [formValues, dataSource, form]);

        const handleSubmit = () => {
            if (isProcessing || isSubmittingRef.current) return;
            const transOutNo = form.getFieldValue('trans_out_no');
            const warehouseCodeReq = form.getFieldValue('warehouse_code_req');
            const transRequestNo = form.getFieldValue('trans_request_no');

            if (!transOutNo || dataSource.length === 0) {
                notification.warning({
                    message: "Submission Failed",
                    description: "Transfer Out No must exist and there must be at least one item in the table.",
                    placement: "topRight",
                });
                return;
            }

            const rowsWithEmptyLocation = dataSource
                .filter(item => !item.locationCode)
                .map(item => item.key);

            if (rowsWithEmptyLocation.length > 0) {
                setInvalidRowKeys(rowsWithEmptyLocation);
                notification.error({
                    message: "Submission Failed",
                    description: "Location Code is not filled in, please check again!.",
                    placement: "topRight",
                });
                return;
            }

            const hasZeroQtyOut = dataSource.some(item => !item.qtyOut || Number(item.qtyOut) === 0);
            if (hasZeroQtyOut) {
                Modal.warning({
                    title: "Perhatian",
                    content: 'Perhatian nilai "Qty Out" masih 0',
                });
                return;
            }

            setInvalidRowKeys([]);

            Modal.confirm({
                title: 'Confirm Submission',
                content: 'Are you sure you want to submit this transfer out? This action will update stock and cannot be undone.',
                onOk: async () => {
                    if (isSubmittingRef.current) return;
                    isSubmittingRef.current = true;
                    setIsProcessing(true);
                    setAutosaveStatus('stopped');
                    try {
                        const payload = {
                            trans_out_no: transOutNo,
                            warehouse_code_req: warehouseCodeReq,
                            trans_request_no: transRequestNo,
                            details: dataSource
                        };

                        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/submit-transfer-out`, payload);
                        if (response.data && response.data.success) {
                            let logOk = true;
                            try {
                                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/log-spareparts/200/transfer-out`, {
                                    trans_out_no: transOutNo
                                });
                            } catch (logErr: any) {
                                if (logErr?.response?.status === 409) {
                                    logOk = true;
                                } else {
                                    logOk = false;
                                    console.error("Log transfer out error:", logErr);
                                }
                            }

                            notification.success({
                                message: "Submission Successful",
                                description: logOk
                                    ? `Transfer Out No: ${transOutNo} has been successfully submitted.`
                                    : `Transfer Out No: ${transOutNo} submitted, but log spareparts failed to record.`,
                                placement: "topRight",
                            });

                            handleNew();

                        } else {
                            throw new Error(response.data.message || "Submission failed with an unexpected response.");
                        }

                    } catch (error: any) {
                        console.error("Submission failed:", error);
                        if (error?.response?.status === 409) {
                            notification.warning({
                                message: "Already Submitted",
                                description: "Transfer Out ini sudah disubmit sebelumnya.",
                                placement: "topRight",
                            });
                            setIsSubmitDisabled(true);
                        } else {
                            notification.error({
                                message: "Submission Failed",
                                description: "An error occurred while submitting the data. Please check the console for details.",
                                placement: "topRight",
                            });
                            setAutosaveStatus('idle');
                        }
                    } finally {
                        isSubmittingRef.current = false;
                        setIsProcessing(false);
                    }
                },
                onCancel() {
                    console.log('Submission cancelled');
                },

            });
        };

        const showModal = () => {
            setIsModalOpen(true);
        };

        const handleCancel = () => {
            setIsModalOpen(false);
        };

        const showLocationModal = () => {
            const whCode = form.getFieldValue('warehouse_code_req');
            setCurrentWarehouseCode(whCode);
            setIsLocationModalOpen(true);
        };

        const handleLocationModalCancel = () => {
            setIsLocationModalOpen(false);
        };

        const handleLocationSelect = (record: LocationData) => {
            setEditingRecord(prevRecord => {
                if (!prevRecord) return null;
                return {
                    ...prevRecord,
                    locationCode: record.locationCode,
                };
            });
            handleLocationModalCancel();
        };

        const handleEditModalCancel = () => {
            setIsEditModalOpen(false);
            setEditingRecord(null);
        };

        const handleTableauRowDoubleClick = (record: DataType) => {
            setEditingRecord(record);
            setIsEditModalOpen(true);
        };

        const handleEditFormSubmit = (values: any) => {
            if (!editingRecord) return;

            const updatedDataSource = dataSource.map(item => {
                if (item.key === editingRecord.key) {
                    return {
                        ...item,
                        locationCode: values.locationCode,
                        qtyOut: values.qtyOut,
                    };
                }
                return item;
            });

            setDataSource(updatedDataSource);
            handleEditModalCancel();
        };

        const handleCopyFromReceipt = async () => {
            const requestNo = form.getFieldValue('trans_request_no');
            if (!requestNo) {
                notification.warning({
                    message: "No Request Number",
                    description: "Please select a Transfer Request first.",
                    placement: "topRight",
                });
                return;
            }

            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/transfer-request-details/${requestNo}`);
                const detailsData = response.data;

                const missingLocations = detailsData.filter((item: any) => !item.locationCode);
                if (missingLocations.length > 0) {
                    const itemCodes = missingLocations.map((i: any) => i.itemCode).join(", ");
                    Modal.warning({
                        title: 'Lokasi Rack Tidak Ditemukan',
                        content: `(${itemCodes}) ini tidak di temukan lokasi rack pada db rack nya`,
                    });
                }

                const existingItemNumbers = new Set(dataSource.map(item => item.itemNumber));

                const newItems = detailsData
                    .filter((item: any) => !existingItemNumbers.has(item.itemCode))
                    .map((item: any, index: number) => ({
                        key: `${item.itemCode}-${Date.now()}-${index}`,
                        itemNumber: item.itemCode,
                        itemName: item.itemName,
                        uom: item.uom,
                        locationCode: item.locationCode || undefined,
                        qtyRequest: item.qtyRequest,
                        qtyAvailable: item.qtyAvailable,
                        qtyOut: item.qtyRequest,
                    }));

                if (newItems.length > 0) {
                    setDataSource(prevDataSource => [...prevDataSource, ...newItems]);
                    notification.success({
                        message: "Success",
                        description: `${newItems.length} new item(s) have been added.`,
                        placement: "topRight",
                    });
                } else {
                    notification.info({
                        message: "No New Items",
                        description: "All items from the receipt are already in the table.",
                        placement: "topRight",
                    });
                }

            } catch (error) {
                console.error("Failed to fetch details for Copy From Receipt:", error);
                notification.error({
                    message: "Error",
                    description: "Failed to fetch item details from the receipt.",
                    placement: "topRight",
                });
            }
        };

        const handleRowDoubleClick = async (record: SelectedData) => {
            setIsProcessing(true);
            try {

                const [nextNoRes, detailsRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/next-transfer-out-no`),
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/transfer-request-details/${record.requestNo}`)
                ]);

                const { nextTransferOutNo } = nextNoRes.data;
                const detailsData = detailsRes.data;

                const missingLocations = detailsData.filter((item: any) => !item.locationCode);
                if (missingLocations.length > 0) {
                    const itemCodes = missingLocations.map((i: any) => i.itemCode).join(", ");
                    Modal.warning({
                        title: 'Lokasi Rack Tidak Ditemukan',
                        content: `(${itemCodes}) ini tidak di temukan lokasi rack pada db rack nya`,
                    });
                }

                const formattedData: DataType[] = detailsData.map((item: any, index: number) => ({
                    key: `${item.itemCode}-${index}`,
                    itemNumber: item.itemCode,
                    itemName: item.itemName,
                    uom: item.uom,
                    locationCode: item.locationCode || undefined,
                    qtyRequest: item.qtyRequest,
                    qtyAvailable: item.qtyAvailable,
                    qtyOut: item.qtyRequest,
                }));

                const formattedRequestDate = record.requestDate ? new Date(record.requestDate).toLocaleDateString('en-GB') : '';
                const formattedApprovalDate = record.approvalDate ? new Date(record.approvalDate).toLocaleDateString('en-GB') : '';


                form.setFieldsValue({
                    trans_request_no: record.requestNo,
                    trans_request_date: formattedRequestDate,
                    warehouse_code_req: record.fromWhCode,
                    warehouse_name_req: record.fromWhName,
                    warehouse_code_to: record.toWhCode,
                    warehouse_name_to: record.toWhName,
                    purpose: record.purpose,
                    approval_by: record.approvalByName,
                    approval_date: formattedApprovalDate,
                    approval_remark: record.approvalRemark,
                    request_by: record.requestBy,
                    trans_out_no: nextTransferOutNo,
                });

                setDataSource(formattedData);
                setIsDataSelected(true);
                handleCancel();
            } catch (error) {
                console.error("Full dataset fetch failed:", error);
                notification.error({
                    message: "Sync Data Gagal",
                    description: "Koneksi RTO terdeteksi. Silakan coba mengimpor data kembali.",
                    placement: "topRight"
                });
            } finally {
                setIsProcessing(false);
            }
        };

        const columns: TableColumnsType<DataType> = [
            {
                title: "Item Number",
                dataIndex: "itemNumber",
            },
            {
                title: "Item Name",
                dataIndex: "itemName",
            },
            {
                title: "UoM",
                dataIndex: "uom",
            },
            {
                title: "Location Code",
                dataIndex: "locationCode",
            },
            {
                title: "Qty Available",
                dataIndex: "qtyAvailable",
            },
            {
                title: "Qty Request",
                dataIndex: "qtyRequest",
            },
            {
                title: "Qty Out",
                dataIndex: "qtyOut",
            },
        ];

        const handleDelete = () => {
            if (selectedRowKeys.length === 0) {
                notification.warning({
                    message: "No Rows Selected",
                    description: "Please select rows to delete.",
                    placement: "topRight",
                });
                return;
            }

            const newDataSource = dataSource.filter(item => !selectedRowKeys.includes(item.key));
            setDataSource(newDataSource);
            setSelectedRowKeys([]);

            notification.success({
                message: "Success",
                description: `${selectedRowKeys.length} item(s) have been deleted.`,
                placement: "topRight",
            });
        };

        const rowSelection: TableProps<DataType>["rowSelection"] = {
            selectedRowKeys,
            onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
        };

        const handleNew = () => {
            form.resetFields();
            setDataSource([]);
            setIsDataSelected(false);
            setSelectedRowKeys([]);
            setAutosaveStatus('stopped');
            setInvalidRowKeys([]);
            setIsSubmitDisabled(false);

            form.setFieldsValue({
                trans_out_status: "Draft",
                trans_out_date: getFormattedDate(),
                created: userData?.nama,
            });
        };

        const handleVoid = () => {
            const transOutNo = form.getFieldValue('trans_out_no');
            if (!transOutNo) return;
            Modal.confirm({
                title: 'Void Confirmation',
                content: `Are you sure you want to void ${transOutNo}? This will delete data permanently.`,
                okText: 'Yes, Void',
                okType: 'danger',
                onOk: async () => {
                    setIsProcessing(true);
                    try {
                        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/transfer-out/void/${transOutNo}`);
                        notification.success({ message: 'Success', description: 'Data voided successfully' });
                        handleNew();
                    } catch (e) {
                        notification.error({ message: 'Error', description: 'Failed to void data' });
                    } finally {
                        setIsProcessing(false);
                    }
                }
            });
        };

        const handleReportModalCancel = () => {
            setIsReportModalOpen(false);
        };

        const handlePrint = async () => {
            setIsPrinting(true);
            try {
                const headerData = form.getFieldsValue(true);
                const reportPayload = {
                    Header: [{
                        trans_out_no: headerData.trans_out_no || "",
                        trans_out_date: headerData.trans_out_date || "",
                        trans_request_no: headerData.trans_request_no || "",
                        trans_request_date: headerData.trans_request_date || "",
                        warehouse_name_req: headerData.warehouse_name_req || "",
                        warehouse_code_req: headerData.warehouse_code_req || "",
                        warehouse_name_to: headerData.warehouse_name_to || "",
                        warehouse_code_to: headerData.warehouse_code_to || "",
                        purpose: headerData.purpose || "",
                        created: headerData.created || "",
                        approval_by: headerData.approval_by || "",
                        approval_date: headerData.approval_date || "",
                        approval_remark: headerData.approval_remark || "",
                    }],
                    Details: dataSource.map((item, index) => ({
                        no: index + 1,
                        itemNumber: item.itemNumber || "",
                        itemName: item.itemName || "",
                        uom: item.uom || "",
                        locationCode: item.locationCode || "",
                        qtyRequest: Number(item.qtyRequest) || 0,
                        qtyAvailable: Number(item.qtyAvailable) || 0,
                        qtyOut: Number(item.qtyOut) || 0,
                    })),
                };
                await import("stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css");
                await import("stimulsoft-reports-js/Scripts/stimulsoft.reports");
                const viewerModule = await import("stimulsoft-reports-js/Scripts/stimulsoft.viewer");
                const Stimulsoft = viewerModule.Stimulsoft || (window as any).Stimulsoft;
                StartLicense(Stimulsoft);
                setIsReportModalOpen(true);
                setTimeout(() => {
                    const report = Stimulsoft.Report.StiReport.createNewReport();
                    report.loadFile("/reports/TO/TransferOut.mrt");
                    const dataSet = new Stimulsoft.System.Data.DataSet("ReportData");
                    dataSet.readJson(reportPayload);
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.dictionary.synchronize();
                    const options = new Stimulsoft.Viewer.StiViewerOptions();
                    options.toolbar.showOpenButton = true;
                    const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
                    (viewer as any).onOpenReport = (args: any) => {
                        const newReport = args.report;
                        if (newReport) {
                            newReport.regData(dataSet.dataSetName, "", dataSet);
                            newReport.dictionary.synchronize();
                            viewer.report = newReport;
                        }
                    };
                    viewer.report = report;
                    viewer.renderHtml("sti-viewer-container");
                }, 300);
            } catch (err) {
                console.error("Gagal memuat Stimulsoft Report:", err);
                notification.error({ message: "Gagal memuat preview laporan Stimulsoft." });
            } finally {
                setIsPrinting(false);
            }
        };

        return <WrappedComponent {...(props as P)}
            form={form}
            columns={columns}
            rowSelection={rowSelection}
            dataSource={dataSource}
            isModalOpen={isModalOpen}
            showModal={showModal}
            handleCancel={handleCancel}
            handleRowDoubleClick={handleRowDoubleClick}
            isDataSelected={isDataSelected}
            isEditModalOpen={isEditModalOpen}
            handleEditModalCancel={handleEditModalCancel}
            handleTableauRowDoubleClick={handleTableauRowDoubleClick}
            editingRecord={editingRecord}
            isLocationModalOpen={isLocationModalOpen}
            showLocationModal={showLocationModal}
            handleLocationModalCancel={handleLocationModalCancel}
            currentWarehouseCode={currentWarehouseCode}
            handleLocationSelect={handleLocationSelect}
            handleEditFormSubmit={handleEditFormSubmit}
            userWarehouseCode={userData?.warehouse_code}
            handleCopyFromReceipt={handleCopyFromReceipt}
            handleDelete={handleDelete}
            autosaveStatus={autosaveStatus}
            handleNew={handleNew}
            handleSubmit={handleSubmit}
            handleVoid={handleVoid}
            invalidRowKeys={invalidRowKeys}
            isSubmitDisabled={isSubmitDisabled}
            isProcessing={isProcessing}
            handlePrint={handlePrint}
            isPrinting={isPrinting}
            isPrintDisabled={isPrintDisabled}
            isReportModalOpen={isReportModalOpen}
            handleReportModalCancel={handleReportModalCancel}
        />;
    };

    return ComponentWithLogic;
};

export default withTransferOutLogic;